import { LiliTransaction } from '../types/lili-transaction';
import { ExternalTransactionTypes } from '../enum/extranal-transaction-types';
import bugsnagHandler from '../../../services/bugsnag.service';

// Used for the header in transaction details page
export function parseTransactionPrettyType(t: LiliTransaction, translate: any): string {
  switch (t.externalTransactionType) {
    case ExternalTransactionTypes.SWIPE:
    case ExternalTransactionTypes.SWIPE_CASHBACK:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.VISA_CARD');

    case ExternalTransactionTypes.SWIPE_REFUND:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.VISA_CARD_REFUND');

    case ExternalTransactionTypes.PAYMENT:
    case ExternalTransactionTypes.ACH_TRANSFER:
    case ExternalTransactionTypes.DIRECT_DEPOSIT:
      return t.amount > 0
        ? translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.TRANSFER_IN')
        : translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.TRANSFER_OUT');

    case ExternalTransactionTypes.ADJUSTMENT:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.ADJUSTMENT');

    case ExternalTransactionTypes.TAX_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.TAX_BUCKET_MANUAL_SAVE:
    case ExternalTransactionTypes.EMERGENCY_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.EMERGENCY_BUCKET_MANUAL_SAVE:
      return t.trxDescription;

    case ExternalTransactionTypes.CHECK_DEPOSIT_FEE:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.FOR_CHECK_DEPOSIT');

    case ExternalTransactionTypes.LILI_PLAN_FEE:
    case ExternalTransactionTypes.ACH_EXPRESS_FEE:
    case ExternalTransactionTypes.PRO_FEE:
    case ExternalTransactionTypes.FEE:
    case ExternalTransactionTypes.BILL_PAY_FEE:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.FEE');

    case ExternalTransactionTypes.STORE_WITHDRAWAL:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.STORE_WITHDRAWAL');

    case ExternalTransactionTypes.ATM_WITHDRAWAL:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.ATM_WITHDRAWAL');

    case ExternalTransactionTypes.REFERRAL_GIFT:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.REFERRAL_REWARD');

    case ExternalTransactionTypes.CAMPAIGN_GIFT:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.LILI_BOOST');

    case ExternalTransactionTypes.CHECK_DEPOSIT:
    case ExternalTransactionTypes.CHECK_DEPOSIT_REJECTED:
    case ExternalTransactionTypes.CHECK_DEPOSIT_BOUNCED:
    case ExternalTransactionTypes.DEBIT_CARD_DEPOSIT:
    case ExternalTransactionTypes.INCOMING_WIRE:
    case ExternalTransactionTypes.BILL_PAY:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.TRANSFER_IN');

    case ExternalTransactionTypes.EMERGENCY_SAVINGS_ACCOUNT_INTEREST:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.SAVINGS_ACCOUNT_INTEREST');

    case ExternalTransactionTypes.CASH_DEPOSIT:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.CASH_DEPOSIT');

    case ExternalTransactionTypes.DIRECT_DEPOSIT_RETURN:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.TRANSFER_OUT');

    case ExternalTransactionTypes.MAIL_CHECK:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.CHECK_PAYMENT');

    case ExternalTransactionTypes.OUTGOING_WIRE:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.OUTGOING_WIRE');

    case ExternalTransactionTypes.INTERNATIONAL_OUTGOING_WIRE:
    case ExternalTransactionTypes.INTERNATIONAL_INCOMING_WIRE:
      return translate('TRANSACTIONS_FACELIFT.TRANSACTION_TYPES.INTERNATIONAL_WIRE');

    case ExternalTransactionTypes.EXTERNAL_CREDIT_CARD:
      return '';

    default:
      bugsnagHandler.notify(`Got default transaction type: ${t.externalTransactionType}`);
      return 'Unknown';
  }
}
